import React, { useEffect, useState } from 'react';
import {
  useNotification,
  getDataGridHeading,
  pageSizeChangeHandler,
} from 'utils/commonUtils';
import MDBox from 'components/MDBox';
import { Card } from '@mui/material';
import { useDispatch } from 'react-redux';
import { intialPageSize } from 'constants';
import {
  getAdminLink,
  deleteAdminLink,
  getAdminAllLinks,
  viewLinkEngagement,
} from 'layouts/userLinks/services/linksApi';
import AdminManagementDialog from './AdminManagementDialog';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import CustomizedSnackbars from 'components/snackbar/Snackbar';
import DeltaDataGrid from 'utils/CommonDataGrid/CommonDataGrid';
import ViewLinkEngagementDialog from './ViewLinkEngagementDialog';
import {
  setAdminLists,
  setViewEngagementLists,
  setViewEngagementLinkId,
} from 'layouts/userLinks/store/adminLinksSlice/adminLinksSlice';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import { adminLinksColumns, getAdminLinksListData } from './getAdminLinksList';
import CommonDeleteDialog from 'components/Common/CommonDeleteDialog/CommonDeleteDialog';
import { usePermissionCustomHook } from 'layouts/users/userPermissions/utils/permissionsUtils';

const AdminManagementTab = () => {
  const { NotificationPopup, handleErrorResponse } = useNotification();
  const dispatch = useDispatch();
  const canManageAnnouncements = usePermissionCustomHook(
    'CAN_MANAGE_ANNOUNCEMENTS'
  );

  const [adminAllLinks, setAdminAllLinks] = useState({
    page: 1,
    rows: [],
    isLoading: false,
    pageSize: intialPageSize,
  });
  const [isNewLink, setIsNewLink] = useState(false);
  const [adminLinkForm, setAdminLinkForm] = useState(null);
  const [isFormLoading, setIsFormLoading] = useState(false);
  const [selectedLinkId, setSelectedLinkId] = useState(null);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openAdminManagementDialog, setOpenAdminManagementDialog] =
    useState(false);
  const [openViewLinkEngagementDialog, setOpenViewLinkEngagementDialog] =
    useState(false);

  useEffect(() => {
    if (canManageAnnouncements) {
      fetchAdminAllLinks();
    }
  }, []);

  const fetchAdminAllLinks = async () => {
    try {
      setAdminAllLinks((prev) => ({
        ...prev,
        isLoading: true,
      }));
      const adminAllLinksData = await getAdminAllLinks();

      dispatch(setAdminLists(adminAllLinksData));
      setAdminAllLinks((prev) => ({
        ...prev,
        isLoading: false,
        rows: getAdminLinksListData(adminAllLinksData),
      }));
    } catch (error) {
      setAdminAllLinks((prev) => ({
        ...prev,
        isLoading: false,
      }));
      handleErrorResponse(error?.response?.data?.message);
    }
  };

  const handleEdit = async (params) => {
    try {
      const linkId = params?.row?.id;
      setIsNewLink(false);
      setIsFormLoading(true);
      const getData = await getAdminLink(linkId);
      setAdminLinkForm(getData);
      setOpenAdminManagementDialog(true);
      setIsFormLoading(false);
    } catch (error) {
      setIsFormLoading(false);
      handleErrorResponse(error?.response?.data?.message);
    }
  };

  const handleDelete = async (params) => {
    const linkId = params?.row?.id;
    setSelectedLinkId(linkId);
    setOpenDeleteDialog(true);
  };

  const handleViewEngagements = async (params) => {
    const linkId = params?.row?.id;
    try {
      setIsFormLoading(true);
      dispatch(setViewEngagementLinkId(linkId));
      const getLinkEngagementData = await viewLinkEngagement(linkId);
      dispatch(setViewEngagementLists(getLinkEngagementData));
      setOpenViewLinkEngagementDialog(true);
      setIsFormLoading(false);
    } catch (error) {
      setIsFormLoading(false);
      handleErrorResponse(error?.response?.data?.message);
    }
  };

  const handleNewLink = async () => {
    setIsNewLink(true);
    setOpenAdminManagementDialog(true);
  };

  const pageSizeChange = pageSizeChangeHandler(setAdminAllLinks);
  return (
    <>
      <DashboardLayout>
        <CustomizedSnackbars />
        <DashboardNavbar />
        <MDBox>
          <Card>
            {getDataGridHeading('Admin Links', 'New Link', handleNewLink)}
            <DeltaDataGrid
              listData={adminAllLinks}
              columns={adminLinksColumns(
                handleEdit,
                handleDelete,
                handleViewEngagements
              )}
              setListData={pageSizeChange}
            />
            <AdminManagementDialog
              isNewLink={isNewLink}
              adminLinkForm={adminLinkForm}
              isFormLoading={isFormLoading}
              open={openAdminManagementDialog}
              setAdminLinkForm={setAdminLinkForm}
              setOpen={setOpenAdminManagementDialog}
              fetchAdminAllLinks={fetchAdminAllLinks}
            />
            <ViewLinkEngagementDialog
              isFormLoading={isFormLoading}
              open={openViewLinkEngagementDialog}
              setIsFormLoading={setIsFormLoading}
              setOpen={setOpenViewLinkEngagementDialog}
            />
            <CommonDeleteDialog
              snakBarName="Link"
              fetchData={fetchAdminAllLinks}
              commonDeleteId={selectedLinkId}
              commonDeleteApi={deleteAdminLink}
              openDeleteDialog={openDeleteDialog}
              setOpenDeleteDialog={setOpenDeleteDialog}
              contentText="Are you sure you want to delete this link ?"
            />
            <NotificationPopup />
          </Card>
        </MDBox>
      </DashboardLayout>
    </>
  );
};

export default AdminManagementTab;
